import React from 'react';
import MessageDefinitions from '../i18n/MessageDefinitions';
import {FormattedMessage, intlShape, FormattedNumber} from 'react-intl';
import FontAwesome from 'react-fontawesome';
import NumberFormat from 'react-number-format';

function buildOptions(optionTypes) {
  return optionTypes.map(({key, value}) => {
    return <option key={key} value={key}>{value}</option>
  });
}

//TODO: Pass in a component here that can be used in the return function.  Provide a default renderer otherwise.
const NewGoalRow =
  ({
     goalTypes = [],
     onChange,
     onRemove
   }) => {
    const goalOptions = buildOptions(goalTypes);

    const typeChanged = (event) => {
      onChange(event.target.value);
    };

    return <div className="goal-row">
      <div className="goalType goal-cell form-group">
        <label>
          <FormattedMessage {...MessageDefinitions.goalPrompt} />
        </label>
        <select className="form-control" onChange={typeChanged} value="">
          <option value="">Please select</option>
          {goalOptions}
        </select>
      </div>
      <button className="btn btn-link remove" onClick={onRemove}><FontAwesome name="trash-o"/></button>
    </div>;
  };

//TODO: Pass in a component here that can be used to custom render the component.
//TODO: Enhanced validation
const SelectedGoalRow =
  ({
     goalType,
     amount,
     timing = '',
     onChange,
     onRemove,
     qualifier = '',
     isToggle = false
   }) => {
    const {
      key,
      value,
      timingOptions = [],
      disableAmount,
      min = 0,
      max = 0
    } = goalType;

    let timingCell = null;
    if (timingOptions.length && !isToggle) {
      const timingChanged = e => {
        onChange(e, {
          goalType,
          amount,
          timing: e.target.value
        });
      };

      const timingRows = buildOptions(timingOptions, timing);

      timingCell = <div className="goalTiming goal-cell form-group">
        <label htmlFor={`${key}Timing`}>
          <FormattedMessage {...MessageDefinitions.timingDefault} />
        </label>
        <select id={`${key}Timing`} className="form-control" value={timing} onChange={timingChanged}>
          <option value="">Please select</option>
          {timingRows}
        </select>
        {timing ? null : <div className="invalid-feedback">
          <FormattedMessage {...MessageDefinitions.validationRequired} />
        </div>}
      </div>;
    }

    let amountCell = null;
    if (!disableAmount && !isToggle) {
      const amountChanged = (e, {floatValue}) => {
        onChange(e, {
          goalType,
          amount: floatValue,
          timing
        });
      };

      const validateAmount = amount => {
        let message = false;
        const formattedValues = {
          min: <FormattedNumber value={min} style='currency' currency='USD' maximumFractionDigits={2} minimumFractionDigits={2} />,
          max: <FormattedNumber value={max} style='currency' currency='USD' maximumFractionDigits={2} minimumFractionDigits={2} />
        };
        if(!amount){
          message = <FormattedMessage {...MessageDefinitions.validationRequired} />;
        }else if(max && (amount < min || amount > max)){
          message = <FormattedMessage {...MessageDefinitions.validationBetween} values={formattedValues} />;
        }else if(amount < min){
          message = <FormattedMessage {...MessageDefinitions.validationMinimum} values={formattedValues} />;
        }
        return message ? <div className="invalid-feedback">{message}</div> : null;
      };

      amountCell = <div className="goalAmount goal-cell form-group">
        <label htmlFor={`${key}${qualifier}`}>
          <FormattedMessage {...MessageDefinitions.amountDefault} />
        </label>
        <NumberFormat id={`${key}${qualifier}`}
                      className="answer form-control"
                      value={amount}
                      thousandSeparator={true} prefix={'$'}
                      decimalPrecision={0}
                      onChange={amountChanged}/>
        {validateAmount(amount)}
      </div>
    }

    return <div className="goal-row">
      <div className="goalType goal-cell form-group">
        <label>
          <FormattedMessage {...MessageDefinitions.goalPrompt} />
        </label>
        <div className="form-control form-control-plaintext">{value}</div>
      </div>
      {amountCell}
      {timingCell}
      <button className="btn btn-link remove" onClick={onRemove}><FontAwesome name="trash-o"/></button>
    </div>
  };

export {
  NewGoalRow,
  SelectedGoalRow
};



/** WEBPACK FOOTER **
 ** ./src/main/js/goalBuilder/components/GoalRow.js
 **/